import {useMap} from "react-leaflet";
import {useEffect} from "react";


const MapResizeZoom = ({position, zoomDefault}) => {
    const map = useMap();

    useEffect(() => {
        map.setView(position, zoomDefault); // cambia la vista del mapa a la nueva posición
        map.invalidateSize(); // ajusta el tamaño del mapa a su contenedor.
    }, [position, map]);

    return null;
};

export default MapResizeZoom